import { SpaceNotificationPreference } from '@tribeplatform/gql-client/types'

export const MemberNotificationSettingOptions = [
  {
    value: SpaceNotificationPreference.ALL,
    label: 'All activity (new posts & replies)',
    description: 'Notify me about new posts and replies in this space',
  },
  {
    value: SpaceNotificationPreference.NEW_POST,
    label: 'New posts',
    description: 'Notify me about new posts in this space',
  },
  {
    value: SpaceNotificationPreference.NONE,
    label: 'Posts of Interest',
    description:
      'Notify me about new comments and reactions to my posts, and the posts I previously commented on',
  },
]

export const SpaceDefaultNotificationSettingOptions = [
  {
    value: SpaceNotificationPreference.ALL,
    label: 'All activity (new posts & replies)',
    description: 'Notify about new posts and replies',
  },
  {
    value: SpaceNotificationPreference.NEW_POST,
    label: 'New posts',
    description: 'Notify about new posts only',
  },
  {
    value: SpaceNotificationPreference.NONE,
    label: 'Posts of Interest',
    description:
      'Notify members about new comments and reactions to their posts, and the posts they previously commented on',
  },
]
